import { toRGBA } from "../parser/utils";

export default ({ data }) => {
    let {
      label,
      url,
      textColor = {},
      bgColor = {},
      template,
      paddingTop,
      paddingBottom,
      paddingRight,
      paddingLeft,
    } = data;
  
    if (template) {
      template = template
        .replace("{{url}}", url)
        .replace("{{bgColor}}", toRGBA(bgColor))
        .replace("{{textColor}}", toRGBA(textColor))
        .replaceAll("{{label}}", label);
    }
  
    return (
      <div>
        {!!template ? (
          <section style={{ paddingTop, paddingBottom, paddingRight, paddingLeft, }}
            dangerouslySetInnerHTML={{ __html: template }}
          ></section>
        ) : (
          <div>Default WeChat Link Block</div>
        )}
      </div>
    );
  };
  